import { Component, inject, OnInit, OnDestroy, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RuleEditorComponent } from "../rule-editor/rule-editor.component";
import { MatDialogContent , MatDialogClose, MatDialogActions, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { IRuleParentInfo } from '@models/measures.model';

//$rule and $ce are defined in src/assets/js/codeeffects/editor.js
declare var $ce: any;

@Component({
  selector: 'app-rule-editor-modal',
  standalone: true,
  imports: [CommonModule, MatDialogContent, RuleEditorComponent, MatDialogClose, MatDialogActions],
  templateUrl: './rule-editor-modal.component.html',
  styleUrl: './rule-editor-modal.component.css'
})


export class RuleEditorModalComponent implements  OnDestroy   {
  editorId = "new-rule-editor";
  criteriaId = 0;
  componentId = 0;
  ruleGroupId = 0;
  private dialogRef = inject(MatDialogRef<RuleEditorModalComponent>);

  constructor(@Inject(MAT_DIALOG_DATA) public data: { parentInfo: IRuleParentInfo}){
    this.criteriaId = data.parentInfo.criteriaId;
    this.componentId = data.parentInfo.componentId;
    this.ruleGroupId = data.parentInfo.ruleGroupId;
  };
  
  ruleSaved(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    var codeeffects = $ce(this.editorId);

    if(codeeffects != null)
      codeeffects.dispose();
  }
}